import PhoneCall from '@/assets/icons/phone-call-01.svg?react';
import styles from './call-metric-header.module.scss';
import { Flex } from 'antd';
import ArrowTopRight from '@/assets/icons/arrow-up-right.svg?react';
import ArrowDownRight from '@/assets/icons/arrow-down-right.svg?react';
import Icon from '@ant-design/icons';

interface CallMetricHeaderProps {
  calls: number | string;
  change?: number;
  textHeader?: string;
}

export const CallMetricHeader = ({
  calls,
  change,
  textHeader = 'calls:',
}: CallMetricHeaderProps) => {
  const isPositive = change && change > 0;

  const ArrowIcon = isPositive ? ArrowTopRight : ArrowDownRight;
  return (
    <Flex gap={10} align="end" justify="flex-start" className={styles.container}>
      <Icon component={() => <PhoneCall width="24" height="24" stroke={styles.iconColor} />} />
      <p className={styles.callsText}>
        Inbound
        <br />
        {textHeader}
      </p>

      <Flex
        style={{ color: styles.iconColor }}
        align="flex-start"
        className={styles.callsContainer}
      >
        <p className={styles.calls}>{calls}</p>
        {change && (
          <>
            <Icon component={() => <ArrowIcon width="20" height="20" />} />
            <span className={styles.change}>{`${change}%`}</span>
          </>
        )}
      </Flex>
    </Flex>
  );
};
